import React, { useMemo, useState } from 'react';

export const SearchInput: React.FC<{
  options: { id: number; name: string }[];
  placeholder: string;
  onSelect(option: { id: number; name: string }): void;
}> = ({ options, placeholder, onSelect }) => {
  const [query, setQuery] = useState('');

  const matches = useMemo(() => {
    const normalized = query.trim().toLowerCase();
    if (!normalized) return [];

    return options.filter((option) => option.name.toLowerCase().includes(normalized)).slice(0, 10);
  }, [options, query]);

  return (
    <div className="position-relative">
      <input
        className="form-control"
        placeholder={placeholder}
        type="text"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
      />
      {matches.length > 0 && (
        <div className="list-group" style={{ position: 'absolute', zIndex: 10, width: '100%' }}>
          {matches.map((option) => (
            <button
              key={option.id}
              type="button"
              className="list-group-item"
              onClick={() => {
                onSelect(option);
                setQuery('');
              }}
            >
              {option.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
